module.exports = __webpack_public_path__ + "img/81.0e976561.png";